// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionFAQ_wrapper__5AQ5Y","withCols":"SectionFAQ_withCols__mQfku","group":"SectionFAQ_group__2GhXO"};